import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC } from "react";
import { AllMounth, idTypeInBDD } from "../../../../constants/Constants";
import { cellStyle } from "../../parametrage/Pays/RowPays";
import { IHerConsolidationParType } from "./IConsolidationCommission";

interface SecondNiveauConsolidationProps {
  consolidationParType: IHerConsolidationParType;
  consolidationPar: number;
  typeConsolidation: number;
  codeIsoDeviseUser:string;
}

const SeconNiveauConsolidation: FC<SecondNiveauConsolidationProps> = ({
  consolidationParType,
  consolidationPar,
  typeConsolidation,
  codeIsoDeviseUser
}) => {
  return (
    <TableRow>
      {consolidationPar !== 0 && (
        <TableCell style={cellStyle} align="center">
          {consolidationParType?.client}
        </TableCell>
      )}
      {consolidationPar === 2 && (
        <TableCell style={cellStyle} align="center">
          {consolidationParType?.operation}
        </TableCell>
      )}

      {typeConsolidation === 2 && (
        <TableCell style={cellStyle} align="center">
          {AllMounth.find((x) => x.id === consolidationParType?.Mois)?.mounth}
        </TableCell>
      )}
      <TableCell style={cellStyle} align="center">
        {consolidationParType?.Annee}
      </TableCell>
      <TableCell style={cellStyle} align="center">
        {consolidationParType?.ca &&
          Number(consolidationParType?.ca).toFixed(2)} - EUR
      </TableCell>
      <TableCell style={cellStyle} align="center">
        {consolidationParType?.Commission &&
          Number(consolidationParType?.Commission).toFixed(2)} -  {codeIsoDeviseUser ?? "Pas De Devise Commission"}
      </TableCell>
    </TableRow>
  );
};

export default SeconNiveauConsolidation;
